import { handleActions } from 'redux-actions';
import { whatsappActions } from '../../actions/whatsapp';
export const { whatsappGetApps, whatsappSetApps, whatsappGetIntegrations, whatsappSetIntegrations, whatsappUpdateIntegration, whatsappDeleteIntegration, whatsappSetAsyncStatus, } = whatsappActions;
const initialState = {
    apps: [],
    integrations: [],
    meta: {
        asyncStatus: 'loading',
    },
};
export const whatsapp = handleActions({
    [whatsappSetApps.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { apps: action.payload.applications, integrations: [] });
    },
    [whatsappSetIntegrations.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { integrations: [...state.integrations, ...action.payload.integrations] });
    },
    [whatsappSetAsyncStatus.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: action.payload.status }) });
    },
}, initialState);
